import React from 'react'
import QrRedirect from './QrRedirect'

const QrRedirectWithEnv: React.FC = () => (
  <QrRedirect mobileAppGaTrackingId={process.env.MOBILE_APP_GA_TRACKING_ID} />
)

export default QrRedirectWithEnv
